import {
  LOWEST_PRICE_DISCOUNT_PERCENTAGE,
  PERCENTAGE_DISCOUNT,
} from '~/utilities/constants/algolia';

/**
 * Both discount facets carry the same "Discount" label, so only one of them is shown.
 * The lowest price discount facet replaces the regular one on sites with L30D prices,
 * as long as the category offers it.
 *
 * @returns the code of the discount facet to hide
 */
export const getHiddenDiscountFacet = (
  l30DPricesEnabled: boolean | null | undefined,
  visibleFacets: ReadonlyMap<string, unknown> | undefined
): string => {
  const categoryHasL30DDiscountFacet = visibleFacets?.has(LOWEST_PRICE_DISCOUNT_PERCENTAGE);

  if (l30DPricesEnabled && categoryHasL30DDiscountFacet) {
    return PERCENTAGE_DISCOUNT;
  }

  return LOWEST_PRICE_DISCOUNT_PERCENTAGE;
};
